import type { ItemFieldRow } from './item-field-reader';
import { fromBaseRecord, FromBaseStageMissing } from './from-base-context';
import { ftClockCampaignField, ftClockColsFromArr, ftClockCalendarFromRaw, ftCampaignNowSeconds } from '../../shared/campaign-clock';

/** Raw campaign SELECT inputs only; the ordinary clock and activity bars share one seconds basis. */
export function fromBaseStatusCampaignSeconds(context: unknown, time: ItemFieldRow): number {
    const campaign = fromBaseRecord(context) ? context.campaign_arr : null;
    const calendarId = ftClockCampaignField(campaign, 'calendar_id');
    const months = fromBaseRecord(campaign) ? campaign.calendar_months : null;
    const missing = (): never => { throw new FromBaseStageMissing('status-environment-layering', 'status-calendar-months'); };
    if (typeof calendarId !== 'string' || calendarId === '' || ftClockCampaignField(time, 'calendar_id') !== calendarId
        || !Array.isArray(months) || months.length === 0
        || months.some(row => ftClockCampaignField(row, 'item_id') !== calendarId)) return missing();
    const calendar = ftClockCalendarFromRaw({ months }), clock = ftClockColsFromArr(time);
    for (let month = 1; month <= clock.month; month++)
        if (!calendar.months.some(row => row.month_order === month && row.days_in_month > 0)) return missing();
    return ftCampaignNowSeconds(clock, calendar);
}
